/** fields */
export const SET_FIELDS = 'SET_FIELDS'
export const EMPTY_FIELDS = 'EMPTY_FIELDS'

/** config */
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

/** common */
export const LIST = 'LIST'
export const MENU = 'MENU'
export const SNACKBAR = 'SNACKBAR'
export const REDIRECT = 'REDIRECT'
export const NAVIGATION = 'NAVIGATION'
export const LOADING_BTN = 'LOADING_BTN'
export const LOADING_PAGE = 'LOADING_PAGE'
export const LOADING_BACKDROP = 'LOADING_BACKDROP'